<template>
  <view-toolbox
    title="Edit Item Properties"
    back-title="Search Results & Actions"
    :back-count="8"
  >
    <DetailProperties
      :item="item"
    />
  </view-toolbox>
</template>

<script>
import ViewToolbox from '@/components/views/ViewToolbox';
import ViewUtils from '@/components/views/ViewUtils';
import DetailProperties from '@/components/views/shared/DetailProperties';

export default {
  name: 'DetailsItemProperties',
  components: {
    ViewToolbox,
    DetailProperties,
  },
  mixins: [
    ViewUtils,
  ],
  computed: {
    item() {
      const {
        columnIndex,
        groupIndex,
        itemIndex,
        layoutIndex,
      } = this.$route.params;

      return this
        .viewRaw
        ?.results
        ?.columns[layoutIndex]
        ?.groups[groupIndex]
        ?.columns[columnIndex][itemIndex];
    },
  },
};
</script>
